const SvgMessageSmileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M7.083 10.417s1.094 1.25 2.917 1.25c1.823 0 2.917-1.25 2.917-1.25m-.625-4.167h.008m-4.592 0h.009M5.833 15v1.946c0 .444 0 .666.091.78.08.1.2.157.326.157.146 0 .32-.139.666-.416l1.988-1.59c.406-.325.61-.488.836-.603a2.5 2.5 0 01.634-.223c.25-.051.51-.051 1.03-.051H13.5c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.092-1.092C17.5 13.1 17.5 12.4 17.5 11V6.5c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.093C15.6 2.5 14.9 2.5 13.5 2.5h-7c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093C2.5 4.4 2.5 5.1 2.5 6.5v5.167c0 .775 0 1.162.085 1.48a2.5 2.5 0 001.768 1.768c.318.085.705.085 1.48.085zm6.875-8.75a.417.417 0 11-.833 0 .417.417 0 01.833 0zm-4.583 0a.417.417 0 11-.833 0 .417.417 0 01.833 0z"
    ></path>
  </svg>
)

export default SvgMessageSmileIcon
